/**
 * @ngdoc Directive
 * @name vrm-installation-dashboard
 * @example
 */

(function() {
    'use strict';

    angular.module('vrm.components').directive('vrmInstallationDashboard', vrmInstallationDashboard);

    /* @ngInject */
    function vrmInstallationDashboard() {
        return {
            restrict: 'E',
            replace: true,
            template: require('@/angular/modules/vrm-components/installation-dashboard/installation-dashboard.template.html'),
            scope: true
        };
    }
})();
